(() => {
  const root = document.documentElement;
  const media = window.matchMedia('(min-width: 990px)');
  const key = 'clark-listings:grid-layout:v1';
  const defaults = { mobile: 2, desktop: 4 };
  const valid = (value, mode) => Number.isInteger(value) && (mode === 'desktop' ? [3, 4, 5] : [1, 2, 3]).includes(value);
  function read() {
    try {
      const saved = JSON.parse(localStorage.getItem(key)) || {};
      return Object.fromEntries(Object.keys(defaults).map(mode => [mode, valid(saved[mode], mode) ? saved[mode] : defaults[mode]]));
    } catch { return { ...defaults }; }
  }
  let preferences = read();
  let pending = false;
  let boostIndex = 0;
  function connectBoost() {
    const template = document.getElementById('ClarkBoostGridSelector');
    if (!template) return;
    document.querySelectorAll('.boost-sd-right > .boost-sd__product-list').forEach(grid => {
      if (!grid.id) grid.id = `ClarkBoostGrid-${++boostIndex}`;
      grid.setAttribute('data-clark-boost-grid', '');
      grid.querySelectorAll('.boost-sd__product-item').forEach(card => {
        const image = card.querySelector('.boost-sd__product-image-wrapper');
        const quantity = card.querySelector('.boost-sd__inventory-status');
        if (!image || !quantity) return;
        const match = quantity.textContent.trim().match(/^(?:Qty:\s*)?(\d+)(?:\s+available)?$/i);
        if (match) {
          const label = `Qty: ${match[1]}`;
          if (quantity.textContent !== label) quantity.textContent = label;
          quantity.setAttribute('aria-label', `${match[1]} available`);
        }
        if (quantity.parentElement !== image) image.appendChild(quantity);
      });
      const container = grid.parentElement;
      if (!container.querySelector('[data-clark-boost-selector]')) {
        const toolbar = document.createElement('div');
        toolbar.className = 'clark-layout-toolbar';
        toolbar.setAttribute('data-clark-boost-selector', '');
        toolbar.append(template.content.cloneNode(true));
        toolbar.querySelectorAll('button').forEach(button => button.setAttribute('aria-controls', grid.id));
        const controls = container.querySelector('.boost-sd__toolbar-container');
        if (controls) controls.after(toolbar); else grid.before(toolbar);
      } else {
        container.querySelectorAll('[data-clark-boost-selector] button').forEach(button => button.setAttribute('aria-controls', grid.id));
      }
    });
  }
  function align() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      document.querySelectorAll('[data-clark-grid]').forEach(grid => {
        const cards = [...grid.children].map(item => item.querySelector('.product-card-wrapper > .card')).filter(Boolean);
        const selectors = [':scope > .card__content .card__heading', ':scope > .card__content .custom-price-block', ':scope > .card__content .card-sku'];
        selectors.forEach(selector => cards.forEach(card => { const element = card.querySelector(selector); if (element) element.style.minHeight = ''; }));
        const rows = new Map();
        cards.forEach(card => {
          const top = Math.round(card.parentElement.parentElement.getBoundingClientRect().top);
          if (!rows.has(top)) rows.set(top, []);
          rows.get(top).push(card);
        });
        rows.forEach(row => selectors.forEach(selector => {
          const elements = row.map(card => card.querySelector(selector)).filter(Boolean);
          const height = Math.max(0, ...elements.map(element => element.getBoundingClientRect().height));
          elements.forEach(element => { element.style.minHeight = `${height}px`; });
        }));
      });
    });
  }
  function apply() {
    root.style.setProperty('--clark-grid-mobile', preferences.mobile);
    root.style.setProperty('--clark-grid-desktop', preferences.desktop);
    document.querySelectorAll('clark-grid-selector').forEach(selector => selector.update());
    align();
  }
  class GridSelector extends HTMLElement {
    connectedCallback() {
      this.hidden = false;
      this.onclick = event => {
        const button = event.target.closest('button[data-clark-columns]');
        if (!button || !this.contains(button)) return;
        const mode = media.matches ? 'desktop' : 'mobile';
        const value = Number(button.dataset.clarkColumns);
        if (!valid(value, mode)) return;
        preferences[mode] = value;
        try { localStorage.setItem(key, JSON.stringify(preferences)); } catch {}
        apply();
      };
      this.update();
      align();
    }
    update() {
      const mode = media.matches ? 'desktop' : 'mobile';
      this.querySelectorAll('button[data-clark-columns]').forEach(button => {
        const value = Number(button.dataset.clarkColumns);
        button.hidden = !valid(value, mode);
        button.setAttribute('aria-pressed', String(value === preferences[mode]));
      });
    }
  }
  if (!customElements.get('clark-grid-selector')) customElements.define('clark-grid-selector', GridSelector);
  media.addEventListener('change', apply);
  window.addEventListener('resize', align, { passive: true });
  window.addEventListener('storage', event => { if (event.key === key || event.key === null) { preferences = read(); apply(); } });
  document.addEventListener('load', event => { if (event.target instanceof HTMLImageElement && event.target.closest('[data-clark-grid]')) align(); }, true);
  document.addEventListener('shopify:section:load', apply);
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('.boost-sd__product-list, .boost-sd__toolbar-container') || node.querySelector('.boost-sd__product-list'))))) connectBoost();
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-clark-grid]') || node.querySelector('[data-clark-grid]'))))) align();
  }).observe(document.body, { childList: true, subtree: true });
  if (document.fonts) document.fonts.ready.then(align);
  connectBoost();
  apply();
})();
